// Colors and layout values sourced from comms_templates SASS variables (channels/email/stylesheets/variables)
export const C = {
	font: 'Helvetica Neue, Helvetica, Arial, sans-serif',
	primaryBtn: '#ffe600',
	text: '#403a49',
	muted: '#918a9d',
	border: '#e1dde9',
	bodyBg: '#f5f4f7',
	white: '#ffffff',
	thermoBg: '#EBEBEC',
	thermoFill: 'linear-gradient(90deg, #0038bc 34%, #4771ff 75%, #4AAEFF 93%)',
	innerWidth: 540,
};
